import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { LoadingButton } from "@mui/lab";

interface ConfirmDialogProps {
    open: boolean
    title: string
    //message is usually a sentence, but callers may pass markup when the text
    //needs emphasis or a computed suffix
    message: React.ReactNode
    //confirmLabel defaults to the wording used by most of the delete dialogs
    confirmLabel?: string
    confirmColor?: "primary" | "error"
    //loading disables the confirm button and shows a spinner in it, for callers
    //whose confirm action is a request rather than local state
    loading?: boolean
    onConfirm: () => void
    onCancel: () => void
}

//ConfirmDialog is the yes/no dialog used before a destructive action. The button
//ids are fixed rather than configurable because the existing dialogs all share
//them and selectors outside this file depend on them.
export function ConfirmDialog(props: ConfirmDialogProps) {
    return <Dialog open={props.open}>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
            <DialogContentText>{props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button id="cancel-delete-button" variant="outlined" onClick={props.onCancel}>
                Cancel
            </Button>
            <LoadingButton
                id="confirm-delete-button"
                variant="contained"
                color={props.confirmColor || "primary"}
                loading={props.loading || false}
                onClick={props.onConfirm}
                autoFocus
            >
                {props.confirmLabel || "Remove It"}
            </LoadingButton>
        </DialogActions>
    </Dialog>;
}

export default ConfirmDialog;
